import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const VolumeIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <path d="M0,20h5.64V5.38H0v14.62ZM1.17,18.83v-1.52h3.3v1.52H1.17ZM4.47,11.93v1.52H1.17v-1.52h3.3ZM1.17,10.76v-1.52h3.3v1.52H1.17ZM4.47,14.62v1.52H1.17v-1.52h3.3ZM4.47,6.55v1.52H1.17v-1.52h3.3Z" />
  <path d="M7.18,20h5.64V0h-5.64v20ZM8.35,18.83v-1.52h3.3v1.52h-3.3ZM11.65,6.55v1.52h-3.3v-1.52h3.3ZM8.35,5.38v-1.52h3.3v1.52h-3.3ZM11.65,9.24v1.52h-3.3v-1.52h3.3ZM11.65,11.93v1.52h-3.3v-1.52h3.3ZM11.65,14.62v1.52h-3.3v-1.52h3.3ZM11.65,1.17v1.52h-3.3v-1.52h3.3Z" />
  <path d="M14.36,10.47v9.53h5.64v-9.53h-5.64ZM18.83,11.64v1.81h-3.3v-1.81h3.3ZM18.83,14.62v1.52h-3.3v-1.52h3.3ZM15.53,18.83v-1.52h3.3v1.52h-3.3Z" />
 </svg>,
 "Volume"
);
